import React from 'react'
// import {Link} from "react-router-dom"
// import logo from "../images/logo.png"
import circlogo from "../images/circlogo.png"

// function Header(){
//     return(
//         <div className="temp-header">
//             This is the header
//          <a href="https://www.reddit.com/r/dataanalysis/comments/unoys0/google_apprenticeship_response_from_google_2022/?utm_source=share&utm_medium=web2x&context=3" 
//          className="comm-link" target="_blank" rel="noreferrer"> 
//         Yahoo Page
//          </a>
//         </div>
//     )
// }

// export default Header













function Header(){
    return(
        <div className="header-section">
         <div className="logo-div">
              {/* <img src={logo} className="logo" />   */}
              <img src={circlogo} className="logo" alt="logo"/> 
              <h1>Google Applicants</h1>
         </div> 

         <a href="https://www.reddit.com/r/dataanalysis/comments/unoys0/google_apprenticeship_response_from_google_2022/?utm_source=share&utm_medium=web2x&context=3" 
         className="comm-link" target="_blank" rel="noreferrer"> 
         <span className="head-nav">Community</span>
         </a>

        </div>
    )
}

export default Header